<atn-ds-widget [title]="_store.nameSg()">
  <widget-container-actions actions>
    <!-- Those are custom actions passed as a content to this component -->
    <ng-content></ng-content>
  </widget-container-actions>
  <embedded-container />
</atn-ds-widget>
